var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[..._vm.classes, _vm.extendedClass]},[(_vm.disable)?_c('div',{staticClass:"inset-0 absolute"}):_vm._e(),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }